import { h } from "hyperapp";
import PanelItem from "../panel-item";

export default class MyHomePanelItem extends PanelItem {
  init() {
    if (this.inited) {
      return;
    }
    super.init();
  }
  destroy() {
    this.interval = clearInterval(this.interval);
    super.destroy();
  }

  render(state, actions) {
    return super.render("myHome", [
      h(
        "div",
        {
          className: this.core.make("osjs/windows").list()?.length === 0 ? "osjs-panel-my-home panel-active" : "osjs-panel-my-home",
          onclick: () => {
            // Minimize all windows.
            this.core.make("osjs/windows").list()?.map((window) => window.minimize());
          },
        },
        [
          h("i", {
            className: "fa-regular fa-house icon",
          }),
        ],
      ),
    ]);
  }
}
